export default function isContractReview() {
  return window.location.hostname.endsWith("contract-review.com");
}
